export const AiModelProviderNames = {
  openai: 'openai',
} as const;
